export const COMMENT_CREATE_REQUEST = "COMMENT_CREATE_REQUEST";
export const COMMENT_CREATE_SUCCESS = "COMMENT_CREATE_SUCCESS";
export const COMMENT_CREATE_FAIL = "COMMENT_CREATE_FAIL";

export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAIL = "COMMENT_LIST_FAIL";

export const COMMENT_DELETE_REQUEST = "COMMENT_DELETE_REQUEST";
export const COMMENT_DELETE_SUCCESS = "COMMENT_DELETE_SUCCESS";
export const COMMENT_DELETE_FAIL = "COMMENT_DELETE_FAIL";
